import {
	IconButton,
	MimaButton,
	MimaInput,
	MimaText,
	Modal,
	MimaToastUtil,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { amountFormatter } from '../../utils/utils';
import { Field, FieldArray, Formik } from 'formik';
import constant from '../../utils/constant';
import moment from 'moment';
import { toJS } from 'mobx';
import React from 'react';
import { TransactionsController } from '../../controllers';

const FieldInput = ({ field, ...props }) => {
	return <MimaInput {...field} {...props} />;
};

const SplitPayment = ({
	closeModal,
	loading,
	onSubmit,
	actionSplit,
	editState,
	gotoEditState,
	transaction,
	totalExtra,
	validationSchema,
}) => {

	const transactionStatus = transaction?.transaction?.status;
	const transferReceipt = transaction?.transaction?.transfer


	return (
		<Modal closeModal={closeModal}>
			<div className={styles.gp}>
				{!editState && (
					<div className={styles.ps}>
						<MimaText labelTitle="DESCRIPTION" mb={2}>
							{transaction.narration}
						</MimaText>
						<MimaText labelTitle="CUSTOMER" mb={2}>
							{transaction?.order?.invoice?.customer?.fullname || ''}{' '}
						</MimaText>

						<MimaText labelTitle="NAME" mb={2}>
							{transaction.beneficiaryAccountName}
						</MimaText>
						<MimaText labelTitle="TOTAL AMOUNT" mb={2}>
							{amountFormatter(transaction.currencyCode).format(
								transaction.totalAmount
							)}
						</MimaText>
						<MimaText labelTitle="SPLIT AMOUNT" mb={2}>
							{amountFormatter(transaction.currencyCode).format(
								transaction.transactionAmount
							)}
						</MimaText>
						<MimaText labelTitle="BANK" mb={2}>
							{transaction.bankName}
						</MimaText>
						<MimaText labelTitle="ACCOUNT NUMBER" mb={2}>
							{transaction.beneficiaryAccountNumber}
						</MimaText>

						{transaction?.payDeductions.map(pay => (
							<MimaText labelTitle={`Deduct ${pay.description}`} mb={2}>
								{`-${amountFormatter().format(pay.amount || 0)}`}
							</MimaText>
						))}
						{transaction?.payAdditions.map(pay => (
							<MimaText labelTitle={`Add ${pay.description}`} mb={2}>
								{`-${amountFormatter().format(pay.amount || 0)}`}
							</MimaText>
						))}
						<MimaText labelTitle="Status" mb={2}>
							{transaction.status}
						</MimaText>
						<MimaText labelTitle="Payment Date" mb={2}>
							{moment(transaction.paymentDate).format('DD-MM-YYYY hh:mm')}
						</MimaText>
						<MimaText labelTitle="Paid Date" mb={2}>
							{transaction.paidDate
								? moment(transaction.paidDate).format('Do MMMM, YYYY')
								: 'NOT PAID'}
						</MimaText>

						{(transactionStatus === 'PAID') ?
							<MimaButton
								title="Download Payment Receipt"
								variant="filter"
								buttonColor="var(--color-green)"
								onClick={async () => {
									if (transferReceipt === undefined) {
										await TransactionsController.splitPaymentTransactions()
										return MimaToastUtil.error({
											message: "Your receipt is being generated, try again after 60 seconds",
										});
									} else {
										window.open(transferReceipt.transferReceiptUrl)
										MimaToastUtil.success({
											message: constant.Success,
										})
									}
								}} /> : ""}

						{transaction.status === constant.STATUS.PENDING ? (
							<>
								<MimaButton
									buttonColor="var(--color-dark-2)"
									title="Add/Remove"
									variant="colorable"
									onClick={gotoEditState}
									mb={2}
								/>
								<MimaButton
									title="Approve"
									variant="colorable"
									onClick={() => actionSplit(transaction._id, 'APPROVED')}
									mb={2}
									loading={loading}
								/>
								<MimaButton
									title="Void"
									variant="colorable"
									onClick={() => actionSplit(transaction._id, 'VOID')}
									mb={2}
									loading={loading}
								/>
							</>
						) : (
							''
						)}
					</div>
				)}
				{editState && (
					<>
						<Formik
							initialValues={{
								payDeductions: toJS(transaction.payDeductions) || [],
								payAdditions: toJS(transaction.payAdditions) || [],
							}}
							validationSchema={validationSchema()}
							onSubmit={onSubmit}>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<div>
									{values.payDeductions.length ? (
										<MimaText
											mt={2}
											mb={2}
											align="center"
											color="var(--color-primary)"
											variant="bodyBold">
											Deductions
										</MimaText>
									) : (
										''
									)}
									<FieldArray name="payDeductions">
										{({ push, remove }) => (
											<React.Fragment>
												{values.payDeductions?.length
													? values?.payDeductions.map((item, i) => (
														<div key={i}>
															<Field
																name={`payDeductions.${i}.description`}
																type="text"
																component={FieldInput}
																labelTitle="Deduction Description"
															/>

															<Field
																name={`payDeductions.${i}.amount`}
																type="number"
																component={FieldInput}
																labelTitle="Deduction Amount"
																min="0"
															/>

															{i >= 0 && (
																<IconButton
																	variant="remove"
																	onClick={() => remove(i)}
																/>
															)}
															<div
																className={styles.employee__list_line}></div>
														</div>
													))
													: ''}
												<MimaButton
													title={`Add ${values.payDeductions.length > 0 ? 'Another' : ''
														} Deduction`}
													onClick={() =>
														push({
															amount: 0,
															description: '',
														})
													}
													variant="filter"
													mt={2}
												/>
												<MimaText
													mt={3}
													align="center"
													color="var(--color-error)">
													{`${totalExtra(
														values.payDeductions
													)} would be deducted
													`}
												</MimaText>
											</React.Fragment>
										)}
									</FieldArray>
									{values.payAdditions?.length && values.payAdditions?.length ? (
										<MimaText
											mt={5}
											mb={2}
											align="center"
											color="var(--color-primary)"
											variant="bodyBold">
											Additions
										</MimaText>
									) : (
										''
									)}
									<FieldArray name="payAdditions">
										{({ push, remove }) => (
											<React.Fragment>
												{values.payAdditions?.map((_, i) => (
													<div key={i}>
														<Field
															name={`payAdditions.${i}.description`}
															type="text"
															component={FieldInput}
															labelTitle="Addition Description"
														/>

														<Field
															name={`payAdditions.${i}.amount`}
															type="number"
															component={FieldInput}
															labelTitle="Addition Amount"
															min="0"
														/>

														{i >= 0 ? (
															<IconButton
																variant="remove"
																onClick={() => remove(i)}
															/>
														) : (
															''
														)}
														<div className={styles.employee__list_line}> </div>
													</div>
												))}

												<MimaButton
													title={`Add ${values.payAdditions.length > 0 ? 'Another' : ''
														} Fund`}
													type="button"
													onClick={() =>
														push({
															amount: 0,
															description: '',
														})
													}
													variant="filter"
													mt={2}
												/>
												<MimaText mt={2} align="center">
													{`${totalExtra(values.payAdditions)} would be added
													`}
												</MimaText>
											</React.Fragment>
										)}
									</FieldArray>

									<MimaButton
										disabled={loading}
										loading={loading}
										title="Save"
										type="submit"
										onClick={handleSubmit}
										mt={5}
									/>
								</div>
							)}
						</Formik>
					</>
				)}
			</div>
		</Modal>
	);
};

export default SplitPayment;
